var _g, _g2, _g3, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 404,
    height: 314,
    viewBox: "0 0 404 314",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_2_220)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2_220",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.5 195.997C265.666 195.999 265.833 196 266 196C289.748 196 309 176.748 309 153C309 129.252 289.748 110 266 110C265.833 110 265.666 110.001 265.5 110.003V110H254.391C254.793 107.057 255 104.053 255 101C255 64.5492 225.451 35 189 35C152.549 35 123 64.5492 123 101C123 104.439 123.263 107.817 123.77 111.115C120.631 110.386 117.361 110 114 110C90.2518 110 71 129.252 71 153C71 176.748 90.2518 196 114 196C114.168 196 114.335 195.999 114.502 195.997L114.5 196H265.5V195.997Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.5 195.997C265.666 195.999 265.833 196 266 196C289.748 196 309 176.748 309 153C309 129.252 289.748 110 266 110C265.833 110 265.666 110.001 265.5 110.003V110H254.391C254.793 107.057 255 104.053 255 101C255 64.5492 225.451 35 189 35C152.549 35 123 64.5492 123 101C123 104.439 123.263 107.817 123.77 111.115C120.631 110.386 117.361 110 114 110C90.2518 110 71 129.252 71 153C71 176.748 90.2518 196 114 196C114.168 196 114.335 195.999 114.502 195.997L114.5 196H265.5V195.997Z",
    fill: "url(#paint0_linear_2_220)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.5 195.997L265.523 193.997C264.988 193.991 264.474 194.199 264.094 194.575C263.714 194.951 263.5 195.463 263.5 195.997H265.5ZM265.5 110.003H263.5C263.5 110.537 263.714 111.049 264.094 111.425C264.474 111.801 264.988 112.009 265.523 112.003L265.5 110.003ZM265.5 110H267.5C267.5 108.895 266.605 108 265.5 108V110ZM254.391 110L252.41 109.73C252.332 110.302 252.505 110.88 252.885 111.315C253.265 111.75 253.814 112 254.391 112V110ZM123.77 111.115L123.318 113.063C123.964 113.213 124.643 113.033 125.13 112.582C125.617 112.13 125.848 111.467 125.747 110.811L123.77 111.115ZM114.502 195.997L116.072 197.237C116.549 196.632 116.637 195.807 116.297 195.115C115.957 194.423 115.25 193.988 114.479 193.997L114.502 195.997ZM114.5 196L112.931 194.76C112.455 195.362 112.366 196.182 112.7 196.872C113.034 197.562 113.733 198 114.5 198V196ZM265.5 196V198C266.605 198 267.5 197.105 267.5 196H265.5ZM265.477 197.997C265.651 197.999 265.825 198 266 198V194C265.841 194 265.682 193.999 265.523 193.997L265.477 197.997ZM266 198C290.853 198 311 177.853 311 153H307C307 175.644 288.644 194 266 194V198ZM311 153C311 128.147 290.853 108 266 108V112C288.644 112 307 130.356 307 153H311ZM266 108C265.826 108 265.651 108.001 265.477 108.003L265.523 112.003C265.682 112.001 265.841 112 266 112V108ZM263.5 110V110.003H267.5V110H263.5ZM254.391 112H265.5V108H254.391V112ZM256.373 110.27C256.787 107.238 257 104.143 257 101H253C253 103.962 252.799 106.876 252.41 109.73L256.373 110.27ZM257 101C257 63.4446 226.555 33 189 33V37C224.346 37 253 65.6538 253 101H257ZM189 33C151.445 33 121 63.4446 121 101H125C125 65.6538 153.654 37 189 37V33ZM121 101C121 104.542 121.271 108.021 121.793 111.419L125.747 110.811C125.255 107.614 125 104.337 125 101H121ZM124.223 109.167C120.937 108.403 117.514 108 114 108V112C117.207 112 120.326 112.368 123.318 113.063L124.223 109.167ZM114 108C89.1472 108 69 128.147 69 153H73C73 130.356 91.3563 112 114 112V108ZM69 153C69 177.853 89.1472 198 114 198V194C91.3563 194 73 175.644 73 153H69ZM114 198C114.175 198 114.35 197.999 114.525 197.997L114.479 193.997C114.32 193.999 114.16 194 114 194V198ZM116.069 197.24L116.072 197.237L112.933 194.757L112.931 194.76L116.069 197.24ZM265.5 194H114.5V198H265.5V194ZM263.5 195.997V196H267.5V195.997H263.5Z",
    fill: "url(#paint1_linear_2_220)",
    mask: "url(#path-1-inside-1_2_220)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bd_2_220)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_2_220",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343.563 151.351C343.683 151.352 343.804 151.353 343.924 151.353C361.087 151.353 375 137.44 375 120.277C375 103.115 361.087 89.2017 343.924 89.2017C343.804 89.2017 343.683 89.2024 343.563 89.2037V89.2017H335.535C335.825 87.075 335.975 84.9037 335.975 82.6975C335.975 56.3549 314.62 35 288.277 35C261.935 35 240.58 56.3549 240.58 82.6975C240.58 85.1831 240.77 87.6243 241.136 90.0074C238.868 89.4803 236.504 89.2017 234.076 89.2017C216.913 89.2017 203 103.115 203 120.277C203 137.44 216.913 151.353 234.076 151.353C234.197 151.353 234.318 151.352 234.439 151.351L234.437 151.353H343.563V151.351Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343.563 151.351C343.683 151.352 343.804 151.353 343.924 151.353C361.087 151.353 375 137.44 375 120.277C375 103.115 361.087 89.2017 343.924 89.2017C343.804 89.2017 343.683 89.2024 343.563 89.2037V89.2017H335.535C335.825 87.075 335.975 84.9037 335.975 82.6975C335.975 56.3549 314.62 35 288.277 35C261.935 35 240.58 56.3549 240.58 82.6975C240.58 85.1831 240.77 87.6243 241.136 90.0074C238.868 89.4803 236.504 89.2017 234.076 89.2017C216.913 89.2017 203 103.115 203 120.277C203 137.44 216.913 151.353 234.076 151.353C234.197 151.353 234.318 151.352 234.439 151.351L234.437 151.353H343.563V151.351Z",
    fill: "url(#paint2_linear_2_220)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.563 151.351L343.586 149.351C343.052 149.345 342.537 149.553 342.157 149.929C341.777 150.304 341.563 150.816 341.563 151.351H343.563ZM343.563 89.2037H341.563C341.563 89.7381 341.777 90.2503 342.157 90.626C342.537 91.0017 343.051 91.2097 343.586 91.2036L343.563 89.2037ZM343.563 89.2017H345.563C345.563 88.0971 344.668 87.2017 343.563 87.2017V89.2017ZM335.535 89.2017L333.553 88.9315C333.475 89.5037 333.649 90.0818 334.028 90.5169C334.408 90.952 334.957 91.2017 335.535 91.2017V89.2017ZM241.136 90.0074L240.684 91.9555C241.33 92.1057 242.009 91.9253 242.496 91.4741C242.983 91.0228 243.214 90.3594 243.113 89.7033L241.136 90.0074ZM234.439 151.351L236.008 152.59C236.486 151.985 236.573 151.16 236.233 150.468C235.893 149.777 235.186 149.342 234.416 149.351L234.439 151.351ZM234.437 151.353L232.867 150.114C232.392 150.715 232.303 151.535 232.637 152.225C232.971 152.915 233.67 153.353 234.437 153.353V151.353ZM343.563 151.353V153.353C344.668 153.353 345.563 152.458 345.563 151.353H343.563ZM343.54 153.351C343.668 153.352 343.796 153.353 343.924 153.353V149.353C343.811 149.353 343.699 149.352 343.586 149.351L343.54 153.351ZM343.924 153.353C362.192 153.353 377 138.544 377 120.277H373C373 136.335 359.982 149.353 343.924 149.353V153.353ZM377 120.277C377 102.01 362.192 87.2017 343.924 87.2017V91.2017C359.982 91.2017 373 104.219 373 120.277H377ZM343.924 87.2017C343.796 87.2017 343.668 87.2024 343.54 87.2039L343.586 91.2036C343.699 91.2023 343.811 91.2017 343.924 91.2017V87.2017ZM341.563 89.2017V89.2037H345.563V89.2017H341.563ZM335.535 91.2017H343.563V87.2017H335.535V91.2017ZM337.517 89.4719C337.819 87.2559 337.975 84.9944 337.975 82.6975H333.975C333.975 84.8131 333.831 86.8941 333.553 88.9315L337.517 89.4719ZM337.975 82.6975C337.975 55.2503 315.724 33 288.277 33V37C313.515 37 333.975 57.4595 333.975 82.6975H337.975ZM288.277 33C260.83 33 238.58 55.2503 238.58 82.6975H242.58C242.58 57.4595 263.039 37 288.277 37V33ZM238.58 82.6975C238.58 85.2852 238.778 87.8281 239.16 90.3114L243.113 89.7033C242.762 87.4205 242.58 85.081 242.58 82.6975H238.58ZM241.589 88.0592C239.173 87.498 236.658 87.2017 234.076 87.2017V91.2017C236.351 91.2017 238.563 91.4627 240.684 91.9555L241.589 88.0592ZM234.076 87.2017C215.808 87.2017 201 102.01 201 120.277H205C205 104.219 218.018 91.2017 234.076 91.2017V87.2017ZM201 120.277C201 138.544 215.808 153.353 234.076 153.353V149.353C218.018 149.353 205 136.335 205 120.277H201ZM234.076 153.353C234.204 153.353 234.333 153.352 234.461 153.351L234.416 149.351C234.303 149.352 234.189 149.353 234.076 149.353V153.353ZM236.007 152.592L236.008 152.59L232.869 150.112L232.867 150.114L236.007 152.592ZM343.563 149.353H234.437V153.353H343.563V149.353ZM341.563 151.351V151.353H345.563V151.351H341.563Z",
    fill: "url(#paint3_linear_2_220)",
    mask: "url(#path-3-inside-2_2_220)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bdd_2_220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.708 169.3C169.01 165.062 175.798 167.127 176.181 172.486L177.354 188.919C177.963 197.447 169.831 203.936 161.65 201.448C153.47 198.959 150.328 189.041 155.583 182.296L165.708 169.3Z",
    fill: "url(#paint4_linear_2_220)",
    stroke: "url(#paint5_linear_2_220)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.215 169.3C226.517 165.062 233.306 167.127 233.688 172.486L234.862 188.919C235.471 197.447 227.338 203.936 219.158 201.448C210.977 198.959 207.835 189.041 213.09 182.296L223.215 169.3Z",
    fill: "url(#paint6_linear_2_220)",
    stroke: "url(#paint7_linear_2_220)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.723 169.3C284.024 165.062 290.813 167.127 291.196 172.486L292.369 188.919C292.978 197.447 284.845 203.936 276.665 201.448C268.485 198.959 265.342 189.041 270.597 182.296L280.723 169.3Z",
    fill: "url(#paint8_linear_2_220)",
    stroke: "url(#paint9_linear_2_220)",
    strokeWidth: 2
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_bdd_2_220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.882 214.82C184.183 210.583 190.972 212.647 191.354 218.006L192.528 234.439C193.137 242.968 185.004 249.456 176.824 246.968C168.644 244.48 165.501 234.561 170.756 227.817L180.882 214.82Z",
    fill: "url(#paint10_linear_2_220)",
    stroke: "url(#paint11_linear_2_220)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.468 214.82C232.77 210.583 239.559 212.647 239.941 218.006L241.115 234.439C241.724 242.968 233.591 249.456 225.411 246.968C217.231 244.48 214.088 234.561 219.343 227.817L229.468 214.82Z",
    fill: "url(#paint12_linear_2_220)",
    stroke: "url(#paint13_linear_2_220)",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_2_220",
    x: 0,
    y: 0,
    width: 338,
    height: 261,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2_220"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -21,
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.113725 0 0 0 0 0.14902 0 0 0 0 0.27451 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_2_220",
    result: "effect2_dropShadow_2_220"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2_220",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bd_2_220",
    x: 132,
    y: 0,
    width: 272,
    height: 216.353,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2_220"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -21,
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.113438 0 0 0 0 0.148981 0 0 0 0 0.275 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_2_220",
    result: "effect2_dropShadow_2_220"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2_220",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bdd_2_220",
    x: 81.0018,
    y: 118.031,
    width: 253.4,
    height: 149.955,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2_220"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -21,
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.113438 0 0 0 0 0.148981 0 0 0 0 0.275 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_2_220",
    result: "effect2_dropShadow_2_220"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.1375 0 0 0 0 0.74125 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2_220",
    result: "effect3_dropShadow_2_220"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_2_220",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_bdd_2_220",
    x: 96.1754,
    y: 163.551,
    width: 186.972,
    height: 149.955,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2_220"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -21,
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.113438 0 0 0 0 0.148981 0 0 0 0 0.275 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_2_220",
    result: "effect2_dropShadow_2_220"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.1375 0 0 0 0 0.74125 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2_220",
    result: "effect3_dropShadow_2_220"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_2_220",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_220",
    x1: 190,
    y1: -16.5,
    x2: 190,
    y2: 218.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_220",
    x1: 190,
    y1: 35,
    x2: 190,
    y2: 196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_220",
    x1: 297,
    y1: 38.5,
    x2: 297,
    y2: 164.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_220",
    x1: 289,
    y1: 35,
    x2: 289,
    y2: 151.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_220",
    x1: 175.905,
    y1: 154.585,
    x2: 161.359,
    y2: 202.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#138EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_220",
    x1: 175.905,
    y1: 154.585,
    x2: 161.359,
    y2: 202.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_220",
    x1: 233.413,
    y1: 154.585,
    x2: 218.867,
    y2: 202.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#138EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2_220",
    x1: 233.413,
    y1: 154.585,
    x2: 218.867,
    y2: 202.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2_220",
    x1: 290.92,
    y1: 154.585,
    x2: 276.374,
    y2: 202.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#138EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2_220",
    x1: 290.92,
    y1: 154.585,
    x2: 276.374,
    y2: 202.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2_220",
    x1: 191.079,
    y1: 200.105,
    x2: 176.533,
    y2: 247.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#138EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2_220",
    x1: 191.079,
    y1: 200.105,
    x2: 176.533,
    y2: 247.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2_220",
    x1: 239.666,
    y1: 200.105,
    x2: 225.12,
    y2: 247.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#138EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2_220",
    x1: 239.666,
    y1: 200.105,
    x2: 225.12,
    y2: 247.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRain);
export default __webpack_public_path__ + "static/media/rain.3936be8aa7f11bc26dc3d2b59b585db6.svg";
export { ForwardRef as ReactComponent };